<template>
  <div class="rolling-board">
    <div class="title">{{ props.title }}</div>
    <div ref="wrapRef" class="content-wrapper">
      <div ref="contentRef" class="content">
        <div v-for="(item, index) in props.data" :key="index" v-html="item.innerHTML" :style="{ color: item.color, backgroundColor: item.bgColor }" class="item"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { debounce } from '@safety/shared-utils'

const props = defineProps({ data: Array, title: String }) //data.item:{innerHTML,color,bgColor}
const wrapRef = ref(null)
const contentRef = ref(null)
let animate = null

const setScroll = debounce(function () {
  //判断content内容是否溢出,如果是,则添加滚动效果,总滚动距离为溢出高度
  animate?.cancel()
  const wrap = wrapRef.value
  const content = contentRef.value
  if (content && content.offsetHeight > wrap.offsetHeight) {
    const overHeight = content.offsetHeight - wrap.offsetHeight
    let annimateDuaration = (props.data.length * 5 * (overHeight / content.offsetHeight)).toFixed(2)
    annimateDuaration = annimateDuaration < 2 ? 2 : annimateDuaration
    animate = content.animate([{ transform: 'translateY(0)' }, { transform: `translateY(-${overHeight}px)` }], {
      duration: annimateDuaration * 1000,
      iterations: Infinity,
      direction: 'alternate',
      easing: 'linear'
    })
  }
}, 1500)

defineExpose({ resize: setScroll })
onMounted(setScroll)
watch(() => props.data, setScroll)
</script>

<style lang="scss" scoped>
.rolling-board {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.title {
  color: white;
  text-shadow:
    2px 2px 10px rgba(255, 255, 255, 0.3),
    -2px -2px 10px rgba(255, 255, 255, 0.3);
  font-size: 1.2em;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
}
.content-wrapper {
  width: 100%;
  overflow: hidden;
  flex: 1;
}
.content {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}
.item {
  width: 100%;
  line-height: 1.5em;
  font-size: 1em;
  color: white;
  overflow: hidden;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
}
</style>
